<template>
  <div class="box">
    <el-radio-group v-model="radioType" class="tab1">
      <el-radio label="出库到机构"></el-radio>
      <el-radio label="出库到个人"></el-radio>
    </el-radio-group>
    <el-radio-group v-model="radio1" class="tab">
      <el-radio-button label="单台设备出库"></el-radio-button>
      <el-radio-button label="批量设备出库"></el-radio-button>
    </el-radio-group>
    <el-form
      v-show="radio1 == '批量设备出库' && radioType == '出库到机构'"
      :model="rule"
      :rules="rules"
      ref="forms"
      class="demo-ruleForm"
      label-width="100px"
    >
      <div v-show="radioType == '出库到机构'">
        <el-form-item label="机构名称" prop="insId">
          <el-select v-model="rule.insId">
            <el-option value="" label="请选择"></el-option>
            <el-option
              v-for="x in selectList"
              :key="x.id"
              :value="x.id"
              :label="x.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备列表" prop="file">
          <input type="file" name="file" @change="getFile($event)" />
        </el-form-item>
        <el-form-item label="">
          <el-link target="_blank" :href="url" :underline="false">
            <el-button type="text">下载设备文件模版</el-button>
          </el-link>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">提交</el-button>
          <el-button @click="block">返回</el-button>
        </el-form-item>
      </div>
      <div v-show="radioType == '出库到个人'">
        <!-- <el-form-item label="机构名称" prop="insId">
        <el-select v-model="rule.insId">
          <el-option value="" label="请选择"></el-option>
          <el-option
            v-for="x in selectList"
            :key="x.id"
            :value="x.id"
            :label="x.name"
          ></el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="手机号码" prop="userId">
          <Individual-customers
            :showOnly="true"
            :handleUserChange="handleUserChange"
          ></Individual-customers>
        </el-form-item>
        <el-form-item label="设备列表" prop="file">
          <input type="file" name="file" @change="getFile($event)" />
        </el-form-item>
        <el-form-item label="">
          <el-link target="_blank" :href="url" :underline="false">
            <el-button type="text">下载设备文件模版</el-button>
          </el-link>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">提交</el-button>
          <el-button @click="block">返回</el-button>
        </el-form-item>
      </div>
    </el-form>
    <el-form
      v-show="radio1 == '单台设备出库' && radioType == '出库到机构'"
      :model="rule2"
      :rules="rules2"
      ref="forms2"
      class="demo-ruleForm"
      label-width="100px"
    >
      <div v-show="radioType == '出库到机构'">
        <el-form-item label="机构名称" prop="ins_id">
          <el-select v-model="rule2.ins_id">
            <el-option value="" label="请选择"></el-option>
            <el-option
              v-for="x in selectList"
              :key="x.id"
              :value="x.id"
              :label="x.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备号" prop="dev_id">
          <el-input
            placeholder="请输入设备号"
            v-model="rule2.dev_id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="使用状态" prop="use_status">
          <el-select v-model="rule2.use_status">
            <el-option value="official" label="正式使用"></el-option>
            <el-option value="probation" label="试用"></el-option>
            <el-option value="test" label="测试"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-show="radioType == '出库到个人'">
        <el-form-item label="手机号码" prop="userId">
          <Individual-customers
            :showOnly="true"
            :handleUserChange="handleUserChange"
          ></Individual-customers>
        </el-form-item>
        <el-form-item label="设备号" prop="dev_id">
          <el-input
            placeholder="请输入设备号"
            v-model="rule2.dev_id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="使用状态" prop="use_status">
          <el-select v-model="rule2.use_status">
            <el-option value="official" label="正式使用"></el-option>
            <el-option value="probation" label="试用"></el-option>
            <el-option value="test" label="测试"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="关联场景" prop="join">
        <el-radio-group v-model="rule2.join">
          <el-radio label="1">仓库</el-radio>
          <el-radio label="2">门店</el-radio>
          <el-radio label="3">运输</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit2">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
    <!-- 个人的form -->
    <el-form
      v-show="radio1 == '单台设备出库' && radioType == '出库到个人'"
      :model="rule3"
      :rules="rules3"
      ref="forms3"
      class="demo-ruleForm"
      label-width="100px"
    >
      <el-form-item label="手机号码" prop="userId">
        <Individual-customers
          :showOnly="true"
          :handleUserChange="handleUserChange"
        ></Individual-customers>
      </el-form-item>
      <el-form-item label="设备号" prop="dev_id">
        <el-input
          placeholder="请输入设备号"
          v-model="rule3.dev_id"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="使用状态" prop="use_status">
        <el-select v-model="rule3.use_status">
          <el-option value="official" label="正式使用"></el-option>
          <el-option value="probation" label="试用"></el-option>
          <el-option value="test" label="测试"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联场景" prop="join">
        <el-radio-group v-model="rule3.join">
          <el-radio label="1">仓库</el-radio>
          <el-radio label="2">门店</el-radio>
          <el-radio label="3">运输</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit3">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
    <el-form
      v-show="radio1 == '批量设备出库' && radioType == '出库到个人'"
      :model="rule4"
      :rules="rules4"
      ref="forms4"
      class="demo-ruleForm"
      label-width="100px"
    >
      <!-- <el-form-item label="机构名称" prop="insId">
        <el-select v-model="rule.insId">
          <el-option value="" label="请选择"></el-option>
          <el-option
            v-for="x in selectList"
            :key="x.id"
            :value="x.id"
            :label="x.name"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="手机号码" prop="userId">
        <Individual-customers
          :showOnly="true"
          :handleUserChange="handleUserChange"
        ></Individual-customers>
      </el-form-item>
      <el-form-item label="设备列表" prop="file">
        <input type="file" name="file" @change="getFile($event)" />
      </el-form-item>
      <el-form-item label="">
        <el-link target="_blank" :href="url" :underline="false">
          <el-button type="text">下载设备文件模版</el-button>
        </el-link>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit4">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import IndividualCustomers from "../../customer/individualCustomers.vue";

export default {
  data() {
    return {
      name: "edit",
      radio1: "单台设备出库",
      radioType: "出库到机构",
      url: this.getEnv(),
      rule: {
        insId: "",
        file: [],
      },
      rules: {
        file: { required: true, message: "请上传文件" },
        insId: { required: true, message: "请选择机构" },
      },
      selectList: [],
      selectList2: [],
      phoneList: [],
      rule2: {
        dev_id: "",
        ins_id: "",
        use_status: "official",
        join: "",
      },
      rule3: {
        dev_id: "",
        use_status: "official",
        user_id: "",
        join: "",
      },
      rule4: {
        file: [],
        userId: "",
      },
      rules2: {
        dev_id: { required: true, message: "请输入设备号" },
        ins_id: { required: true, message: "请选择机构" },
        use_status: { required: true, message: "请选择使用状态" },
        join: { required: true, message: "请选择关联场景" },
      },
      rules3: {
        dev_id: { required: true, message: "请输入设备号" },
        use_status: { required: true, message: "请选择使用状态" },
        user_id: { required: true, message: "请选择用户信息" },
        join: { required: true, message: "请选择关联场景" },
      },
      rules4: {
        file: { required: true, message: "请上传文件" },
        userId: { required: true, message: "请选择用户信息" },
      },
    };
  },
  async created() {
    this.$http.post("/manage/institution/listAll").then((data) => {
      this.selectList = data["data"]["data"];
    });
    this.$http.get("/manage/rom-model/list").then((data) => {
      this.selectList2 = data["data"]["data"];
    });
    // this.$http.get("/manage/rom-model/list").then((data) => {
    //   this.phoneList = data["data"]["data"];
    // });
  },
  methods: {
    handleUserChange(props) {
      if (this.radio1 == "单台设备出库") {
        this.rule3.user_id = props.id;
      } else {
        this.rule4.userId = props.id;
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return (
          document.location.protocol +
          "//" +
          "test.baitengfa.com/manage/dev/download/template"
        );
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return (
          document.location.protocol +
          "//" +
          "dev.iotmanage.baitengfa.com/manage/dev/download/template"
        );
      } else if (location.host == "iotmanage.baitengfa.com") {
        return (
          document.location.protocol +
          "//" +
          "iotmanage.baitengfa.com/manage/dev/download/template"
        );
      }
    },
    submit() {
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          let headers = {
            "Content-Type": "multipart/form-data",
          };
          let formData = new FormData();

          formData.append("file", this.rule.file);

          if (this.radioType == "出库到机构") {
            formData.append("userType", 0);
            this.rule.insId && formData.append("insId", this.rule.insId);
          } else {
            formData.append("userType", 1);
            this.role.userId && formData.append("userId", this.role.userId);
          }
          this.$http
            .post("/manage/stock/outStock", formData, { headers: headers })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/out");
              } else {
                this.rule.file = "";
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    submit4() {
      this.$refs["forms4"].validate((valid) => {
        if (valid) {
          let headers = {
            "Content-Type": "multipart/form-data",
          };
          let formData = new FormData();

          formData.append("file", this.rule4.file);

          formData.append("userType", 1);
          formData.append("userId", this.rule4.userId);

          this.$http
            .post("/manage/stock/outStock", formData, { headers: headers })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/out");
              } else {
                this.rule.file = "";
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    block() {
      this.$router.push("/inventory/out");
    },
    getFile(event) {
      var file = event.target.files;
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (this.radioType == "出库到个人") {
            this.rule4.file = file[i];
          } else {
            this.rule.file = file[i];
          }
        }
      }
    },
    submit2() {
      this.$refs["forms2"].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.$http
            .post("/manage/stock/outOneStock", {
              ...this.rule2,
              userType: this.radioType == "出库到机构" ? 0 : 1,
            })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/out");
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    submit3() {
      this.$refs["forms3"].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.$http
            .post("/manage/stock/outOneStock", {
              ...this.rule3,
              userType: this.radioType == "出库到机构" ? 0 : 1,
            })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/out");
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
  },
  components: { IndividualCustomers },
};
</script>
<style scoped>
.tab {
  margin-bottom: 20px;
  margin-left: 100px;
  margin-top: 50px;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: start;
}
</style>
